import { Controller } from "@hotwired/stimulus"

// A page waiting on a background job should not depend on the broadcast
// arriving. Turbo Streams are the fast path; this is what happens when they do
// not come — a dropped websocket, a tab asleep for an hour, or a production
// stack where Action Cable is not wired up at all. The page finds out anyway,
// just later.
//
// Disconnects itself the moment the panel it lives in is replaced, so a page
// that has finished waiting stops asking.
export default class extends Controller {
  static values = { interval: { type: Number, default: 15000 } }

  connect() {
    this.timer = setInterval(() => this.tick(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    // Nothing to see while the tab is in the background, and reloading it
    // there just burns requests on a page nobody is looking at.
    if (document.visibilityState !== "visible") return

    if (window.Turbo) {
      window.Turbo.visit(window.location.href, { action: "replace" })
    } else {
      window.location.reload()
    }
  }
}
